import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useUser } from '../context/UserContext';
import { globals } from '../globals';
import "./UserProfile.css";

const API_URL = `${globals.homepageUrl}/php/usermanager.php`;

function UserProfile() {
  const { user, setUser } = useUser();
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    surname: '',
    email: '',
    password: '',
    role: '',
  });

  useEffect(() => {
    if (user) {
      setFormData({
        id: user.id,
        name: user.name || '',
        surname: user.surname || '',
        email: user.email || '',
        password: '',
        role: user.role || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const handleSave = async () => {
    // 🔎 Verifica se l'utente ha inserito almeno un campo relativo alla password
    const wantsPasswordChange =
      !!formData.newPassword || !!formData.confirmPassword || !!formData.currentPassword;

    if (wantsPasswordChange) {
      // ✅ Controllo: nuova password e conferma devono combaciare
      if (formData.newPassword !== formData.confirmPassword) {
        alert("La nuova password e la conferma non corrispondono.");
        return; // blocca il salvataggio
      }

      // ✅ Controllo: deve essere inserita la vecchia password
      if (!formData.currentPassword) {
        alert("Inserisci la vecchia password per confermare la modifica.");
        return; // blocca il salvataggio
      }
    }

    // 📦 Prepara il payload da inviare al PHP
    // NB: il backend si aspetta i campi 'password' e 'currentPassword'
    const payload = {
      id: formData.id,
      name: formData.name,
      surname: formData.surname,
      email: formData.email,
      role: formData.role,
      password: wantsPasswordChange ? formData.newPassword : "", // nuova password
      currentPassword: wantsPasswordChange ? formData.currentPassword : "" // vecchia password
    };

    try {
      // 🚀 Invio al server
      const res = await axios.put(API_URL, payload);

      // ⚠️ Se il server restituisce un errore (es. vecchia password errata)
      if (res.data?.error) {
        alert(res.data.error);
        return;
      }

      // ⚠️ Se non c'è success = true, qualcosa non ha funzionato
      if (!res.data?.success) {
        alert("Aggiornamento non riuscito.");
        return;
      }

      // 🎉 Aggiornamento riuscito: aggiorna il contesto utente
      setUser({
        ...user,
        name: formData.name,
        surname: formData.surname,
        email: formData.email,
        role: formData.role
        // non salvare la password in chiaro nel contesto
      });
      alert("Dati aggiornati con successo!");

      // 🔄 Reset dei campi password nel form
      setFormData(prev => ({
        ...prev,
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      }));
    } catch (error) {
      console.error("Errore durante il salvataggio:", error);

      // ⚠️ Se il server ha restituito un errore HTTP (es. 401 Unauthorized)
      if (error.response?.data?.error) {
        alert(error.response.data.error);
      } else if (error.response?.status === 401) {
        alert("Password attuale errata.");
      } else {
        alert("Errore durante l'aggiornamento dei dati");
      }
    }
  };




  if (!user) {
    return <div>Effettua il login per visualizzare il profilo.</div>;
  }

  return (
    <div className="user-profile">
      <h2>Profilo Utente</h2>
      <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
        <div>
          <label>Nome</label>
          <input name="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div>
          <label>Cognome</label>
          <input name="surname" value={formData.surname} onChange={handleChange} required />
        </div>
        <div>
          <label>Email</label>
          <input name="email" type="email" value={formData.email} onChange={handleChange} required />
        </div>
        {/* 🔑 Campi per la modifica password */}
        <div>
          <label>Vecchia password</label>
          <input
            type="password"
            name="currentPassword"
            value={formData.currentPassword}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Nuova password</label>
          <input
            type="password"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Digita nuova password</label>
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Ruolo</label>
          <input name="role" value={formData.role} readOnly disabled />
        </div>
        <button type="submit">Salva</button>
      </form>
    </div>
  );
}

export default UserProfile;
